<template>

    <div class="c-pagination" v-if="pagination.length > 1">
        <span class="c-pagination__caption">Strona</span>
        <ul class="c-pagination__pages">
            <li
                v-for="(page, index) in firstPages"
                :key="index"
                class="c-pagination__page">
                <router-link
                    :to="getQuery(firstPages[index])"
                    class="c-pagination__page-link"
                    :class="{ 'c-pagination__page-link--active' : currentPage == page }">
                    {{ page }}
                </router-link>
            </li>

            <li v-if="lastPage" class="c-pagination__page">&hellip;</li>

            <li v-if="lastPage" class="c-pagination__page">
                <router-link
                    :to="getQuery(lastPage)"
                    class="c-pagination__page-link"
                    :class="{ 'c-pagination__page-link--active' : currentPage == lastPage }">
                    {{ lastPage }}
                </router-link>
            </li>
        </ul>
    </div>

</template>


<script>

import {mapGetters} from 'vuex'

const PAGE_RANGE = 5

export default {

    name: 'VPagination',

    props: {
        value: Number,
        name: {
            type: String,
            default: 'page'
        }
    },

    computed: {
        pagination() {
            return Array.from(new Array(this.value), (val, index) => index + 1)
        },
        currentPage() {
            return parseInt(this.$route.query[this.name]) || 1
        },
        firstPages() {
            var from = 0
            var to = this.pagination.length

            if (this.pagination.length > PAGE_RANGE + 1) {
                from = this.currentPage - Math.floor(PAGE_RANGE / 2)
                to = this.currentPage + Math.floor(PAGE_RANGE / 2) + 1

                if (from < 0) {
                    from = 0
                    to = PAGE_RANGE
                } else if (to >= this.pagination.length - 1) {
                    from = this.pagination.length - PAGE_RANGE - 1
                    to = this.pagination.length - 1
                }
            }

            return this.pagination.slice(from, to)
        },
        lastPage() {
            if (this.pagination.length > PAGE_RANGE + 1) {
                return this.pagination[this.pagination.length - 1]
            }
            return false
        }
    },

    methods: {
        getQuery(page) {
            let query = JSON.parse(JSON.stringify(this.$route.query))
            query[this.name] = page
            return {query: query}
        },
        checkPages() {
            if (this.currentPage > this.value) {
                this.$router.push(this.getQuery(this.pagination[this.pagination.length - 1]))
            }
        }
    },

    watch: {
        value() {
            this.checkPages()
        }
    },

    mounted() {
        this.checkPages()
    }

}

</script>


<style lang="scss">

@import '~Style/_utils.scss';

.c-pagination {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    margin-top: 40px;

    @include bp($screen-md) {
        margin: 20px 30px 0 30px;
    }
    @include bp($screen-sm) {
        margin: 20px 15px 0 15px;
    }

    &__caption {
        display: inline-block;
        margin-right: 1rem;
    }
    &__pages {
        display: inline-block;
    }
    &__page {
        display: inline-block;
        margin: 0.16rem;
        color: $c-text-muted;

        &:first-of-type {
            margin-left: 0;
        }
        &:last-of-type {
            margin-right: 0;
        }
        &-link {
            display: flex;
            align-items: center;
            justify-content: center;
            text-align: center;
            width: 2rem;
            height: 2rem;
            border: 1px solid $c-fourth;
            border-radius: .2rem;
            color: $c-fourth;
            font-weight: bold;
            transition: .15s;

            &--active,
            &:hover {
                border-color: $c-primary;
                background-color: $c-primary;
                color: $c-white;
            }
            &--active {
                pointer-events: none;
            }
        }
    }
}

</style>

